import React, { useState, useEffect, ChangeEvent, useRef } from "react"
import { CustomHeader } from "../../../components/headers/CustomHeader"
import { CustomModal } from "../../../components"
import { useHistory } from "react-router-dom"
import {
   Button,
   CardBody,
   IconButton,
   Input,
   Spinner,
   Typography,
   Tooltip,
} from "@material-tailwind/react"
import { BASEURL, DEFAULTPRIMARYCOLOR } from "../../../util"
import { FiDownloadCloud } from "react-icons/fi"
import Papa from "papaparse"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { getColorCode } from "../../../colorCodes"
import moment from "moment"
import PerPageAndPagination from "../../../components/paginations/perpageAndPagination"
import { toast } from "react-toastify"

import testData from "./data"

type MessageType = {
   code : string
   created_at : string
   reciepient : {
      first_name : string
      last_name : string
      phone : string | number
   }
}


const SentMessages = () => {
   const [searchText, setSearchText] = useState("")
   const [activePage, setActivePage] = useState(1)
   const [open, setOpen] = useState(false)
   const [selectedRow, setSelectedRow] = useState<MessageType>()
   const [startDate, setStartDate] = useState("")
   const [endDate, setEndDate] = useState("")
   const [otpList, setOtpList] = useState<MessageType[]>([])
   const [loadingData, setLoadingData] = useState(false)

   const {
      companyId,
      user: stateUser,
      token,
   } = useSelector((state: RootState) => state.auth)

   const userData = stateUser
   const [colors, setColors] = useState<string[]>()

    useEffect(() => {
       if (userData) {
         // const data: UserType = JSON.parse(userData)
   
         const colors = getColorCode(stateUser?.colors)
   
         setColors(colors)
       }
     }, [userData, stateUser])
   
   const handleStartDateChange = (event: any) => {
      const value = event.target.value
      const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
      setStartDate(formattedValue)
   }

   const handleEndDateChange = (event: any) => {
      const value = event.target.value
      const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
      setEndDate(formattedValue)
   }

   const handleSearch = (e: any) => {
      setSearchText(e.target.value)
      setActivePage(1)
   }

   const clearDateFilters = () => {
      setStartDate("");
      setEndDate("");
   };

   const handleRowClick = (item: MessageType) => {
      setSelectedRow(item)
      setOpen(true)
   }

   const fetchOTPs = async () => {
      try {
         setLoadingData(true)
         let options: any = {
            method: "GET",
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`,
            }
         }

         const req = await fetch(`${process.env.REACT_APP_BASE_URL}/get-broker-otps?user_id=${companyId}`,options)
         const res = await req.json()
         if (!req.ok) {
            console.error("Failed to fetch OTPs", res);
            return
         }

         // console.log("Fetched OTPs:", res);
         setOtpList(res.results); 
      } catch (error) {
         console.log(error)
      } finally {
         setLoadingData(false)
         }
      }

   // console.log("test data", testData)

   useEffect(() => {
      fetchOTPs()
   }, [])

   const filterData = (filter: MessageType) => {
      const date = moment(filter?.created_at).format("LLL")
      const isTextMatch =
         filter?.code
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchText?.toLowerCase()) ||
         (filter?.reciepient?.first_name + " " + filter?.reciepient?.last_name)
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchText?.toLowerCase()) ||
         filter?.reciepient?.phone
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchText?.toLowerCase()) ||
         date?.toString()?.toLowerCase()?.includes(searchText?.toLowerCase())

      return isTextMatch
   }

   const totalItems = otpList?.filter(filterData)?.filter((item: any) => {
      const normalizeDate = (date: Date | string): Date => {
      const normalizedDate = new Date(date)
      normalizedDate.setHours(0, 0, 0, 0)
      return normalizedDate
   }
   const from =
      (startDate as any) instanceof Date
         ? normalizeDate(startDate)
         : normalizeDate(startDate)
   const to =
      (endDate as any) instanceof Date
         ? normalizeDate(endDate)
         : normalizeDate(endDate)
   const dateCreated = normalizeDate(item?.date_created)

   if (startDate && endDate) {
      return dateCreated >= from && dateCreated <= to
   } else if (startDate) {
      return dateCreated >= from
   } else if (endDate) {
      return dateCreated <= to
   }
   return true
   })

   const [currentPage, setCurrentPage] = useState(0)
   const [itemsPerPage, setItemsPerPage] = useState(10)

   useEffect(() => {
      if (searchText || startDate || endDate) {
      setCurrentPage(0)
      }
   }, [searchText, startDate, endDate])

   const endOffset = currentPage + itemsPerPage
   const paginatedData = totalItems?.slice(currentPage, endOffset)

   return (
      <>
         {/* <CustomModal
            open={open}
            onClose={() => setOpen(false)}
            title="Message"
            className="min-h-[20dvh] h-fit"
            showClose
            size={"sm"}
            children={
               <>
                  <div className="h-[100%] mx-2 flex place-center justify-center">
                     <div className="place-center place-content-center">
                        <Typography
                        className="text-md font-normal text-black text-justify"
                        > 
                           Your message will appear here
                        </Typography>
                     </div>
                  </div>
               </>
            }
         /> */}
         <CustomHeader title="Sent Messages" />
         <div className="w-full">
            <div className="flex flex-wrap  flex-col gap-2  bg-white p-3 rounded-lg">
               {/* <div className="flex shrink-0 flex-col gap-2 justify-end sm:flex-row pl-10">
               <Tooltip content="Export as CSV">
                  <Button
                     // onClick={handleDownload}
                     variant="filled"
                     className="capitalize text-sm font-normal flex flex-wrap gap-2"
                     size="sm"
                  >
                     <FiDownloadCloud size={20} />
                     <span>Download csv</span>
                  </Button>
               </Tooltip>
               </div> */}
               <div className="p-3 flex gap-x-2 items-center flex-col 2xl:flex-row gap-y-3">
                  <div className="w-full mr-3">
                     <Input
                        crossOrigin="anonymous"
                        label="Search"
                        value={searchText}
                        onChange={handleSearch}
                        icon={<i className="fas fa-search text-base"></i>}
                     />
                  </div>
      
                  <div className="flex flex-col md:flex-row gap-3 justify-between mb-0">
                     <div className="flex items-center space-x-2">
                        <label className="font-semibold text-gray-700">From</label>
                        <Input
                        type="datetime-local"
                        value={startDate.slice(0, -1)} // Remove 'Z' for input value
                        onChange={handleStartDateChange}
                        size="md"
                        className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                        labelProps={{
                           className: "before:content-none after:content-none",
                        }}
                        />
                     </div>
                     <div className="flex items-center space-x-2">
                        <label className="font-semibold text-gray-700">To</label>
                        <Input
                        type="datetime-local"
                        value={endDate.slice(0, -1)} // Remove 'Z' for input value
                        onChange={handleEndDateChange}
                        size="md"
                        className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                        labelProps={{
                           className: "before:content-none after:content-none",
                        }}
                        />
                     </div>
                     <div className="flex items-center space-x-2">
                        <Tooltip content="Clear All Date filters">
                           <Button
                              onClick={clearDateFilters}
                              variant="filled"
                              className="capitalize text-sm font-normal flex flex-wrap gap-2"
                              size="sm"
                           >
                              <span>Clear</span>
                           </Button>
                        </Tooltip>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="w-full rounded-lg lg:col-span-2 overflow-hidden mt-10">
            <div
            style={{
            color:
               colors?.length! > 1
                  ? `${colors![0]?.toLowerCase()}`
                  : `${DEFAULTPRIMARYCOLOR}`,
            }}
            className="bg-black p-3 "
            >     
               <Typography className="text-lg">
                  List of Sent OTP Messages
                  {testData?.results && (
                     <span className="text-white text-sm bg-admin-red p-1 rounded-md">
                     {otpList?.length}
                     </span>
                  )}
               </Typography>
            </div>
            <div className="p-3 bg-white rounded-b-xl">
               <CardBody className="shadow-none overflow-x-scroll px-0 py-0  rounded-none">
               <table className=" bg-white w-full min-w-max table-auto">
                  <thead className="bg-white sticky z-50 top-0">
                     <tr>
                     {[
                        "Reciepient",
                        "Code",
                        "Created At",
                        "Status",
                     ].map((head) => (
                        <th
                           key={head}
                           className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                        >
                           <Typography
                           color="black"
                           className="font-bold text-sm text-black leading-none opacity-70 capitalize"
                           >
                           {head}
                           </Typography>
                        </th>
                     ))}
                     </tr>
                  </thead>
                  <tbody>
                     {paginatedData.map((item, index) => {
                        const isLast =
                        index === testData.results.length - 1
                        const classes = isLast
                           ? "p-2  text-center"
                           : "p-2 border-b-2 border-blue-gray-50 text-center"
                     
                        return (
                           <tr className={classes}
                           key={index} 
                           >
                           <td className={classes}
                           // onClick={() => handleRowClick(item)}
                           >
                              <Typography
                                 variant="small"
                                 color="blue-gray"
                                 className="font-bold text-xs capitalize"
                              >
                                 Name:{" "}
                                 <span className=" font-normal">
                                    {item?.reciepient.first_name} {item?.reciepient.last_name}
                                 </span>
                              </Typography>
                              <Typography
                                 variant="small"
                                 color="blue-gray"
                                 className="font-bold text-xs capitalize"
                              >
                                 Phone:{" "}
                                 <span className=" font-normal">
                                 {item?.reciepient.phone}
                                 </span>
                              </Typography>
                           </td>
                           <td className={classes}>
                              <Typography
                                 variant="small"
                                 color="blue-gray"
                                 className="font-bold text-xs capitalize cursor-pointer"
                                 onClick={() => {
                                    navigator.clipboard.writeText(item?.code || "");
                                    toast.success("Copied");
                                 }}
                              >
                                 {item?.code}
                              </Typography>
                           </td> 
                           <td className={classes}>
                              <Typography
                                 variant="small"
                                 color="blue-gray"
                                 className="font-normal text-xs capitalize"
                              >
                                 {moment(item?.created_at).format("LLL")}
                              </Typography>
                           </td>
                           <td className={classes}>
                              <Typography
                                 variant="small"
                                 color="blue-gray"
                                 className="font-normal text-xs capitalize"
                              >
                                 N/A
                              </Typography>
                           </td>
                           {/* <td className={classes}>
                              <Button
                                 onClick={() => handleRowClick(item)}
                                 variant="filled"
                                 color="green"
                                 className="font-normal capitalize"
                              >
                                 View more
                              </Button>
                           </td> */}
                        </tr>
                        )
                     })}
                  </tbody>
               </table>   
               </CardBody>
               {paginatedData?.length! === 0 && 
                  !loadingData && 
                  (
                  <div className="mt-10 flex items-center justify-center">
                  <Typography color="black" variant="h6">
                     No data found
                  </Typography>
                  </div>
               )}

               {loadingData ? (
                  <div className="mt-10 flex items-center justify-center">
                  <Spinner className="w-10 h-10" />
                  </div>
               ) : null}

               {/* Paginator */}
               {paginatedData &&
                           // !loading &&
               paginatedData?.length !== 0 &&(
               // !loading && (
               <PerPageAndPagination
                  total={totalItems.length!}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  perPage={itemsPerPage}
                  setPerPage={setItemsPerPage}
               />
               )}
            </div>          
         </div>
      </>
   )
}

export default SentMessages
